import { infoFlyout } from '~/composables/flyout';
import { useRoute, useRouter } from '#imports';

export type DcbStep = 'form' | 'mailSent' | 'alreadyRegistered' | 'inactive' | 'retargeting';

export const useDoubleOptIn = (step: Ref<DcbStep>) => {
  const route = useRoute();
  const router = useRouter();
  const { dcbVouchersDOI } = useShopApi();

  if (import.meta.client) {
    // User with E-Mail Token for validation
    watch(
      () => route.query.doubleOptinToken,
      async (doubleOptinToken) => {
        if (!doubleOptinToken) return;

        // We have to remove the token, before opening a Dialog, otherwise the Dialog will be closed.
        const query = { ...route.query };
        delete query.doubleOptinToken;
        await router.replace({ query });

        dcbVouchersDOI(doubleOptinToken as string)
          .then(async () => {
            // show success page

            step.value = 'mailSent';
            setTimeout(() => {
              infoFlyout(
                'Vielen Dank, du erhältst künftig Infos rund um „Zahl einfach per Handyrechnung“'
              );
            }, 100);
          })
          .catch((error: Error) => {
            console.error(error);
            infoFlyout(
              'Die E-Mail Adresse konnte nicht aktiviert werden oder du bist bereits im Erinnerungsservice angemeldet.',
              {
                type: 'error',
              }
            );
          });
      },
      {
        immediate: true,
      }
    );
  }
};
